import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;


const MenuService = {
  getList: async () => {
    const response = await apiService.get("/menu/menu-tree");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/testpreparations/${id}`);
    return response.data;
  },
};

export default MenuService;
